// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3BHBa","insightsList":"newBusinessInsightsMenu_insightsList__tHTqv","active":"newBusinessInsightsMenu_active__1H3HM"};